import { createStore } from "vuex";
import api from "@/api";

import licensesModule from "./modules/licenses.js";
import sidebarModule from "./modules/sidebar.js";
import userDetailsModule from "./modules/user_details.js";

import { useAttributesStore } from "@/stores/attributes";
import { useCustomerStore } from "@/stores/customer";
import { useMiscStore } from "@/stores/misc";
import { useModulesStore } from "@/stores/modules";
import { useOverviewStore } from "@/stores/overview";
import { useAccessStore } from "@/stores/access";
import { useAttributeLogStore } from "@/stores/attributeLog";

const getters = {
    isStaff: (state) => {
        return state.loginUser.is_staff;
    },
    hasBeenModified: (state, getters) => {
        const access = useAccessStore();
        const attributes = useAttributesStore();
        const customerStore = useCustomerStore();
        const misc = useMiscStore();
        const modules = useModulesStore();

        return (
            getters["userDetails/hasBeenModified"] ||
            access.hasBeenModified ||
            getters["licenses/hasBeenModified"] ||
            modules.hasBeenModified ||
            attributes.hasBeenModified ||
            misc.hasBeenModified ||
            customerStore.hasBeenModified
        );
    },
};

const mutations = {
    updateUser: (state, user) => {
        state.user = user;
    },
    setLoginUser: (state, user) => {
        state.loginUser = user;
    },
};

// A per-user store missing from here shows a stale user with no error.
export const applyUser = ({ commit }, user) => {
    const overview = useOverviewStore();
    const modules = useModulesStore();
    const attributes = useAttributesStore();
    const misc = useMiscStore();
    const access = useAccessStore();
    const customer = useCustomerStore();
    const attributeLog = useAttributeLogStore();

    commit("updateUser", user);
    commit("userDetails/updateUser", user);
    commit("licenses/updateUser", user);
    commit("sidebar/updateUser", { user });

    overview.updateUser(user);
    modules.updateUser(user);
    attributes.updateUser(user);
    misc.updateUser(user);
    attributeLog.updateUser(user);
    access.updateUser(user);

    customer.open([user, null]);
};

// Does not navigate: routing from a store action loops back into a refetch.
export const loadUser = async ({ dispatch }, idUser) => {
    if (!idUser) {
        throw "Undefined id";
    }

    const user = await api.users.get(idUser);

    return dispatch("applyUser", user);
};

const actions = {
    applyUser,
    loadUser,
    updateTree: async ({ commit }) => {
        const users = await api.users.list();
        commit("sidebar/setUsers", users);
    },
};

export default createStore({
    state: {},
    getters,
    mutations,
    actions,
    modules: {
        sidebar: sidebarModule,
        userDetails: userDetailsModule,
        licenses: licensesModule,
    },
});
